<template>
    <v-content class="gb owner-suport">
        <v-container class="fill-width" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" md="12" class>
                    <v-card :loading="status==='loading'" class="fill-width card-theme custom-container">
                        <SupportForm/>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
    import {mapState} from "vuex";
    import SupportForm from "@/views/owner/support/support";

    export default {
        name: "Support",
        computed: {
            ...mapState({
                status: state => state.Support.status,
            })
        },
        components: {
            SupportForm
        }
    };
</script>

<style scoped lang="scss">
    .owner-suport {
        .custom-input-position-text input {
            margin: 8px 0px;
        }

        .custom-container {
            max-width: 1222px !important;
            min-height: 632px;
            top: 30px;
            margin-bottom: 50px !important;
            padding: 20px 62px 50px 62px;
        }

        .summary-label {
            color: #061d47;
            font-size: 15.5px;
            margin-top: 1rem;
        }

        .alert-login-vendor h3 {
            font-size: 22px;
            margin: 3px 0px 0.24rem 13px;
        }

        .alert-login-vendor p {
            font-size: 14px;
            margin: 0 0 7px 13px;
            letter-spacing: 1.34px;
        }

        .summary-value {
            color: #3c5fa9;
            font-size: 18px;
        }

        .p-expansion-login {
            margin-left: 1.5rem;
            font-size: 17.2px;
            line-height: 2.13rem;
        }

        .padding-payment-inputs {
            padding-bottom: 0.2rem;
        }

        .link-check {
            color: #29abe2;
            text-decoration: none;
        }

        .ml-14 {
            margin-left: 56px;
        }

        .ml-16 {
            margin-left: 64px;
        }

        .account-information-checkbox {
            position: absolute;
            right: 0;
            top: 1rem;
        }

        .alert-value-font {
            font-size: 18px;
        }

        .small-checkbox > label {
            font-size: 14px;
        }

        /* number color to list in modal-box */
        li.number-color {
            color: #29abe2;
        }

        li.number-color > a {
            cursor: default;
        }

        .medium-font {
            font-weight: 500 !important;
        }

        textarea {
            height: 115px !important;
            min-height: 115px !important;
        }

        .title-how-help {
            font-size: 16px !important;
            font-weight: 700;
            line-height: 14px !important;
        }

        .title-custom {
            margin: 12px 0 5px 0;
            margin-left: 0 !important;
        }

        .container-form {
            margin: 35px auto 0;
        }

        .form-support {
            padding-left: 0 !important;
        }

        @media (max-width: 960px) {
            .alert-login-vendor h3 {
                font-size: 16px;
            }
            .alert-login-vendor p {
                font-size: 13px;
            }
            .p-expansion-login {
                margin-left: auto;
                font-size: 12px;
            }
            .ml-14 {
                margin-left: auto;
            }
            .ml-16 {
                margin-left: auto;
            }
        }

        @media (max-width: 1400px) {
            .account-information-checkbox {
                position: absolute;
                right: unset;
                top: 2.5rem;
            }
        }
        @media (max-width: 600px) {
            .title-how-help {
                font-size: 14px !important;
            }
        }
    }
</style>
